import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {useState} from 'react';
import {Grid, IconButton} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from 'lodash';
import clsx from 'clsx';
import AssessmentButton from './assessmentButton';
import InformationBox from '../../../../../components/other/informationBox';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        margin: '10px 0',
    },
    left: {
        marginLeft: 'auto',
    },
    bold: {
        fontWeight: 'bold',
    },
    folder: {
        color: theme.palette.mode === 'light' ? "#D1D4D9" : "#ffffff",
    },
    red: {
        color: theme.palette.error.main,
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 15,
        paddingTop: 5,
        paddingLeft: 20,
    },
    counter: {
        backgroundColor: theme.palette.inPatient.accordionBackground,
        borderRadius: 6,
        padding: 5,
        width: 30,
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
    },
}));

const AssessmentFolder = ({folderType, disableSave, assessments = []}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const [expanded, setExpanded] = useState(false);

    const handleExpand = () => {
        setExpanded(!expanded);
    };

    return (
        <Grid container className={classes.root}>
            <FolderRoundedIcon className={clsx(classes.folder, folderType === 'Mandatory' && classes.red)}/>

            <div className={classes.bold}>
                {folderType.toUpperCase()}
            </div>

            {/*<div className={classes.counter}>*/}
            {/*    {assessments.length || 0}*/}
            {/*</div>*/}

            <IconButton
                size="small"
                onClick={handleExpand}
                className={classes.left}
            >
                {expanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
            </IconButton>

            {expanded &&
                <Grid item xs={12}>
                    {_.isEmpty(assessments) &&
                        <InformationBox type="info">
                            {t('There are no assessment to display')}
                        </InformationBox>
                    }

                    {!_.isEmpty(assessments) &&
                        <div className={classes.list}>
                            {assessments.map(ass => (
                                <AssessmentButton disableSave={disableSave} assessment={ass} key={ass.code}/>
                            ))}
                        </div>
                    }
                </Grid>
            }
        </Grid>
    );
};

export default AssessmentFolder;